import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FAQs from './pages/FAQs';
import { ParallaxProvider } from 'react-scroll-parallax';
import TravelAccommodation from './pages/TravelAccommodation';
import WeekendSchedule from './pages/WeekendSchedule';
import About from './pages/OurStory';
import OurStory from './pages/OurStory';
import WeddingParty from './pages/WeddingParty';
import Gifts from './pages/Gifts';
import { GuestProvider, useGuest } from './contexts/GuestContext';
import { PasswordGate } from './components/PasswordGate';
import { VenueBadge } from './components/VenueBadge';

function AppContent() {
  const { isAuthenticated, setGuestType } = useGuest();

  if (!isAuthenticated) {
    return <PasswordGate onPasswordSuccess={setGuestType} />;
  }

  return (
    <ParallaxProvider>
      <div>
        <VenueBadge />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/wedding-party" element={<WeddingParty />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/travel-and-accommodation" element={<TravelAccommodation />} />
            <Route path="/weekend-schedule" element={<WeekendSchedule />} />
            <Route path="/gifts" element={<Gifts />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ParallaxProvider>
  );
}

function App() {
  return (
    <Router>
      <GuestProvider>
        <AppContent />
      </GuestProvider>
    </Router>
  );
}

export default App;
